/*
 * @Description: 渲染方法
 * @Date: 2020-01-04 14:32:23
 */
import Config from '@/config/index';

// TODO: 需要以指令方式重构
function handlePics(index, type = 'array') {
  let i = index || 0;
  return function(h, ctx, row, column, index) {
    let pics = row[column.property] || [];
    if (type === 'string' && typeof pics === 'string') {
      pics = pics.split(',');
    }
    if (typeof pics === 'string') {
      return pics && pics !== 'null' ? (
        <el-image
          src={pics}
          preview-src-list={[pics]}
          onClick={handleClickItem.bind(null, ctx.parent)}
        />
      ) : (
        <span>-</span>
      );
      // return (
      //   <div className="el-table-image_container" onClick={click.bind(this)}>
      //     {pics && pics !== 'null' ? (
      //       <img className="el-table_img" src={pics} alt="" />
      //     ) : (
      //       '-'
      //     )}
      //   </div>
      // );
    }
    return pics[i] && pics[i] !== 'null' ? (
      <el-image
        src={pics[i]}
        preview-src-list={[pics[i]]}
        onClick={handleClickItem.bind(null, ctx.parent)}
      />
    ) : (
      <span>-</span>
    );
    // return (
    //   <div className="el-table-image_container" onClick={click.bind(this)}>
    //     {pics[i] && pics[i] !== 'null' ? (
    //       <img className="el-table_img" src={pics[i]} alt="" />
    //     ) : (
    //       '-'
    //     )}
    //   </div>
    // );
  };
}
// TODO: 需要以指令方式重构
function renderShowImage(h, ctx, row, column, index) {
  return row[column.property] && row[column.property] !== 'null' ? (
    <el-image
      src={row[column.property]}
      preview-src-list={[row[column.property]]}
      onClick={handleClickItem.bind(null, ctx.parent)}
    />
  ) : (
    <span>-</span>
  );

  // function click(index) {
  //   // ctx.parent.showImage([row[column.property][0]])
  //   ctx.parent.showImage([row[column.property]], 0, true);
  // }

  // return (
  //   <div className="el-table-image_container" onClick={click.bind(this, 0)}>
  //     {row[column.property] && row[column.property] !== 'null' ? (
  //       <img className="el-table_img" src={row[column.property]} alt="" />
  //     ) : (
  //       '-'
  //     )}
  //   </div>
  // );
}
//---------------------------------------//
function blsuthFilter(prop) {}
function authFilter(prop) {
  // todo 是否可以直接使用
  // 审核状态 1 审核中 2 审核通过  3 审核不通过'
  // console.log(i.authStatus);
  return function(row) {
    if (row.is_out == 1) {
      return '已退出';
    }
    switch (+row[prop]) {
      case 1:
        return '审核中';
      case 2:
        return '审核通过';
      case 3:
        return '审核不通过';
      case 4:
        return '任务失效';
      default:
        return '未提交审核';
    }
  };
  // return '待处理'
}

function rarestyle(prop) {
  return function(scope) {
    let { row } = scope;
    let rate = +row[prop] * 100;
    if (rate === 100) {
      return 'color:orange';
    } else if (rate > 80) {
      return 'color:#2499FA';
    } else {
      return '';
    }
  };
}
function completeRare(prop) {
  return function(row, column, cellValue) {
    return `${parseInt(+row[prop] * 10000) / 100}%`;
  };
}
function digitImage(key) {
  let feedback = require('@/assets/images/feedback.png');
  let forward = require('@/assets/images/forward.png');
  let target = key === 'feedback' ? feedback : forward;
  // window.open(
  //   url,
  //   'newwindow',
  //   'height=600,left=100,top=70,width=400,location=no,locationbar=no,status=yes,resizable=yes,scrollbars=yes'
  // );
  return function(h, ctx, row, column, index) {
    let url = `${Config.webViewUrl}/html/index.html#/visitDetail?id=${row.id}&platform=oss`;
    if (key === 'feedback') {
      url = `${Config.webViewUrl}/html/index.html#/visit?id=${row.id}&showType=feedback&platform=oss`;
    }
    function showModel() {
      ctx.parent.$myDailog({
        dialogName: () => import('../child/openIframe.vue'),
        //todo 增加组合的连接
        options: {
          url,
          width: '400px'
        }
      });
    }
    return (
      <div>
        <img class="digit-table-image" onClick={showModel} src={target}></img>
      </div>
    );
  };
}

const flat = arr => {
  return arr.reduce((pre, cur) => {
    return pre.concat(Array.isArray(cur) ? flat(cur) : cur);
  }, []);
};
/**
 * @description:  string:
 *                $$为自定义占位标识，可存在多个连接,[]内部不可以在有$$
                  $$R=[] r为替换 []为替换内容 r2则标识类型2时替换 r默认为1
                  $$D 为该标识时删除该项， d2 d如上
                  $$A=[] a标识为添加 []为添加内容 , d2 d如上
                  object: 
                        对象中以$$X_x作为key,value为替换内容
                  {
                    $$R_x: []
                  }
                  
                  =右侧必须是数组 如果是string 需要parse ，对象中的不需解析
 * @param {Array,number} 
 * @return: Array<any>
 */
const $$Seat = (list, currentType) => {
  const A = `A_${currentType}`;
  const D = `D_${currentType}`;
  const R = `R_${currentType}`;

  // 一个字段只可能存在一种情况
  let l = list.map((item, index) => {
    if (typeof item === 'string' && item) {
      if (item.includes('$$')) {
        item = item.replace(/'/, '"');
        let sp = item.split('$$');
        let resp;
        // 从后往前判断
        for (let i = sp.length; i--; i > -1) {
          // 添加字段
          if (sp[i].includes(A)) {
            let firstField = sp[0] ? [sp[0]] : [];
            let fields = sp[i].split(A + '=')[1];
            fields = JSON.parse(fields);
            resp = [...firstField, ...fields];
            break;
          } else if (sp[i].includes(R)) {
            // 替换字段
            let fields = sp[i].split(R + '=')[1];
            fields = JSON.parse(fields);
            resp = [...fields];
            break;
          } else if (sp[i].includes(D)) {
            // 删除字段直接不返回

            break;
          } else {
            // 无匹配 存在则直接返回
            resp = sp[i];
          }
        }
        // resp有值才返回
        if (resp) {
          return resp;
        }
      } else {
        return item;
      }
    } else if (Object.prototype.toString.call(item) === '[object Object]') {
      const keys = Object.keys(item);

      if (item.hasOwnProperty(`$$${A}`)) {
        return [item, ...item[`$$${A}`]];
      } else if (item.hasOwnProperty(`$$${R}`)) {
        return item[`$$${R}`];
      } else if (item.hasOwnProperty(`$$${D}`)) {
        console.log('skip');
      } else {
        return item;
      }
    }
  });

  return flat(l); // 最后扁平化数组
  // return l.flat() edge兼容有问题
};

/**
 * 点击蒙版关闭 preview-src-list 的图片预览
 */
const handleClickItem = ctx => {
  ctx.$nextTick(() => {
    let domImageMask = document.querySelector('.el-image-viewer__mask'); // 获取遮罩层dom
    if (!domImageMask) {
      return;
    }
    domImageMask.addEventListener('click', () => {
      // 点击遮罩层时调用关闭按钮的 click 事件
      document.querySelector('.el-image-viewer__close').click();
    });
  });
};
export {
  authFilter,
  handlePics,
  rarestyle,
  renderShowImage,
  completeRare,
  digitImage,
  $$Seat,
  handleClickItem
};
